import { hex2rgb } from '@csstools/convert-colors'
import { useCharityStore } from '@/stores/charity'
import { useAuthStore } from '@/stores/auth'
import { useDonorStore } from '@/stores/donor'

export function useTheme() {
  const validateCharity = async () => {
    const store = useCharityStore()
    const auth = useAuthStore()

    if (!store.getCharityInfo || checkNecessaryValues(store.getCharityInfo)) {
      await store.getWhiteLabel(getDomain())
    }

    if (auth.viewAsDonor) {
      const donor = useDonorStore()
      await donor.fetchDonorDetails()
    }

    setColors()
  }

  const getDomain = () => {
    const subdomain = window.location.host.split('.')[0]

    if (subdomain?.search('localhost') !== -1) {
      // return 'clay';
      // return '6f3305e7cfca67f60006';
      // return 'cmn';
      // return 'bsa';
      // return 'directrelief';
      // return '5c516fe7b5c853e0a620';//Equality California
      // return 'alsa';
      // return 'harp';
      // return 'lander';
      return 'beatnb'
      //return 'clay'
      // return 'academyatthelakes';//without campaigns
      // return 'helpingpeople';
      // return 'dream';
    }
    if (window.location.hostname?.search('127.0.0.1') !== -1) {
      return 'beatnb'
    }
    if (subdomain?.search('192') !== -1) {
      return 'clay'
    }
    if (subdomain === 'webapp-staging-3') {
      return 'clay'
    }
    // TODO: just for cloudflare-pages
    if (window.location.host?.search('pages.dev') !== -1) {
      return 'beatnb'
    }
    if (window.location.host?.search('ngrok.io') !== -1) {
      return 'beatnb'
    }
    if (window.location.host?.search('ngrok-free.app') !== -1) {
      return 'clay'
    }
    if (window.location.host?.search('pages.dev') !== -1) {
      return 'beatnb'
    }
    if (subdomain.search('donation-forms-v4') !== -1) {
      return 'beatnb'
    }

    return subdomain
  }

  const setColors = () => {
    const store = useCharityStore()
    const charityInfo = store.getCharityInfo

    if (charityInfo) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.type = 'image/png'
      link.rel = 'shortcut icon'
      link.href = charityInfo.logo_square || charityInfo.logo_transparent

      const root = document.querySelector(':root')

      let prColor = charityInfo.primary_color
      let sdColor = charityInfo.secondary_color

      let [pRed, pGreen, pBlue] = hex2rgb(prColor)
        .map((c) => (c / 100) * 255)
        .map(Math.round)
      let [sRed, sGreen, sBlue] = hex2rgb(sdColor)
        .map((c) => (c / 100) * 255)
        .map(Math.round)

      let pBrightness = Math.sqrt(
        0.299 * Math.pow(parseInt(pRed), 2) +
          0.587 * Math.pow(parseInt(pGreen), 2) +
          0.114 * Math.pow(parseInt(pBlue), 2)
      )

      let sBrightness = Math.sqrt(
        0.299 * Math.pow(parseInt(sRed), 2) +
          0.587 * Math.pow(parseInt(sGreen), 2) +
          0.114 * Math.pow(parseInt(sBlue), 2)
      )
      // Set the color of the text based on the brightness
      if (pBrightness > 224) {
        root.style.setProperty('--primary-color', 'black')
      } else {
        root.style.setProperty('--primary-color', 'white')
      }

      if (sBrightness > 180) {
        root.style.setProperty('--secondary-color', 'black')
      } else {
        root.style.setProperty('--secondary-color', 'white')
      }

      root.style.setProperty('--primary', prColor)
      root.style.setProperty('--primary-opacity', `${prColor}1a`)
      root.style.setProperty('--secondary', sdColor)

      root.style.setProperty(`--primary0075`, `rgba(${pRed}, ${pGreen}, ${pBlue}, 0.075)`)
      root.style.setProperty(`--secondary0075`, `rgba(${sRed}, ${sGreen}, ${sBlue}, 0.075)`)

      root.style.setProperty(`--primary015`, `rgba(${pRed}, ${pGreen}, ${pBlue}, 0.15)`)
      root.style.setProperty(`--secondary015`, `rgba(${sRed}, ${sGreen}, ${sBlue}, 0.15)`)

      root.style.setProperty(`--primary008`, `rgba(${pRed}, ${pGreen}, ${pBlue}, 0.08)`)
      root.style.setProperty(`--secondary008`, `rgba(${sRed}, ${sGreen}, ${sBlue}, 0.08)`)

      root.style.setProperty(`--primary01`, `rgba(${pRed}, ${pGreen}, ${pBlue}, 0.1)`)

      for (let i = 1; i <= 9; i++) {
        root.style.setProperty(`--primary0${i}`, `rgba(${pRed}, ${pGreen}, ${pBlue}, 0.${i})`)
        root.style.setProperty(`--secondary0${i}`, `rgba(${sRed}, ${sGreen}, ${sBlue}, 0.${i})`)
      }
    }
  }

  const checkNecessaryValues = (data) => {
    const necessaryFields = [
      'ein',
      'email',
      'website',
      'campaign.title',
      'campaign.description',
      'charity_name',
      'primary_color',
      'secondary_color',
      'payments_enabled',
      'stripe_connect.api_version',
      'stripe_connect.connect_account_id'
    ]

    for (const fieldPath of necessaryFields) {
      const fields = fieldPath.split('.')
      let fieldValue = data

      for (const field of fields) {
        if (fieldValue && Object.prototype.hasOwnProperty.call(fieldValue, field)) {
          fieldValue = fieldValue[field]
        } else {
          console.error(`Error in validateCharity: Missing value for ${fieldPath}`)
          return false
        }
      }
    }

    return true
  }

  return {
    validateCharity,
    getDomain
  }
}
